//https://www.youtube.com/watch?v=KB7JEnfc7Dc&t=3420s

import React, { useState, useEffect } from "react";
import "./styles.css";
import { Button, FormControl, InputLabel, Input } from "@material-ui/core";
import Message from "./Message";
import db from "./firebase";
import firebase from "firebase";
import FlipMove from "react-flip-move";
import SendIcon from "@material-ui/icons/Send";
import { IconButton } from "@material-ui/core";

export default function App() {
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([{ username: "", message: "" }]);
  const [username, setUsername] = useState("");

  //read
  useEffect(() => {
    db.collection("messages")
      .orderBy("timestamp", "desc")
      .onSnapshot((snapshot) => {
        setMessages(
          snapshot.docs.map((doc) => ({ id: doc.id, message: doc.data() }))
        );
      });
  }, []);

  //if its blank inside [],this code runs ONCE when the app component loads
  useEffect(() => {
    setUsername(prompt("好きな名前を入力して入室してください"));
  }, []); //write

  ///////////////////////////////////////
  //console.log(input);
  //console.log(messages);
  const sendMessage = (event) => {
    event.preventDefault();
    db.collection("messages").add({
      message: input,
      username: username,
      timestamp: firebase.firestore.FieldValue.serverTimestamp()
    });
    //リストにそのまま追加したい場合...をつかう　Spread Attributet
    //第二引数にリストに追加したい要素
    //setMessages([...messages, { username: username, text: input }]);
    setInput("");
  };

  ///////////////////////////////////
  return (
    <div className="App">
      <h2>
        <img
          src="https://facebookbrand.com/wp-content/uploads/2018/09/Header-e1538151782912.png?w=50&h=50"
          style={{ marginTop: "3px", marginRight: "30px" }}
        />
        "{username}" で入室中
      </h2>

      {/*フォームは、ユーザがフォームを送信した際に新しいページに移動する */}
      <form className="app_form">
        <FormControl className="app__formControl">
          {
            //<InputLabel>Enter a message...</InputLabel> //
          }
          <Input
            className="app__input"
            placeholder="Enter a message..."
            value={input}
            onChange={(event) => setInput(event.target.value)}
          />
          <IconButton
            className="app__iconButton"
            disabled={!input.replace(/\s/g, "").length}
            variant="contained"
            color="primary"
            type="submit"
            onClick={sendMessage}
          >
            <SendIcon />
          </IconButton>
        </FormControl>

        {/*
        <Button
          disabled={!input}
          variant="contained"
          color="primary"
          type="submit"
          onClick={sendMessage}
        >
          Send message
        </Button>*/}
      </form>

      <FlipMove>
        {messages.map(({ id, message }) => (
          <Message key={id} username={username} message={message} />
        ))}
      </FlipMove>
    </div>
  );
}
